import React, { useState } from 'react';
import { FixedSizeList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { MailItem, generateMailData } from '../utils/mockData';
import { PullToRefresh } from 'antd-mobile';
import { MailOutline, BillOutline, CheckShieldOutline, ShopbagOutline } from 'antd-mobile-icons';

// Memoized Row Component for performance
const Row = ({ index, style, data }: { index: number; style: React.CSSProperties; data: MailItem[] }) => {
    const item = data[index];

    const getIcon = (type: string) => {
        switch (type) {
            case 'bill': return <BillOutline className="text-blue-400" />;
            case 'security': return <CheckShieldOutline className="text-red-400" />;
            case 'promotion': return <ShopbagOutline className="text-pink-400" />;
            default: return <MailOutline className="text-gray-400" />;
        }
    };

    return (
        <div style={style} className="px-4 py-2">
            <div className={`
                h-full w-full rounded-xl p-4 flex items-start gap-4
                bg-white/5 border border-white/5 active:bg-white/10 transition-colors
                ${!item.read ? 'bg-white/10 border-l-2 border-l-blue-500' : ''}
            `}>
                <div className={`w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-xl shrink-0`}>
                    {getIcon(item.type)}
                </div>

                <div className="flex-1 min-w-0">
                    <div className="flex justify-between items-start mb-1">
                        <span className={`text-sm truncate pr-2 ${!item.read ? 'text-white font-bold' : 'text-gray-300'}`}>
                            {item.sender}
                        </span>
                        <span className="text-xs text-gray-500 shrink-0">{item.time}</span>
                    </div>
                    <div className={`text-sm mb-1 truncate ${!item.read ? 'text-gray-200' : 'text-gray-400'}`}>
                        {item.subject}
                    </div>
                    <div className="text-xs text-gray-500 truncate">
                        {item.preview}
                    </div>
                </div>
            </div>
        </div>
    );
};

export const MailList: React.FC = () => {
    const [data, setData] = useState<MailItem[]>(() => generateMailData(100));

    const handleRefresh = async () => {
        await new Promise(resolve => setTimeout(resolve, 1000));
        // Simulate new data
        setData(prev => [...generateMailData(5), ...prev]);
    };

    return (
        <PullToRefresh onRefresh={handleRefresh}>
            <div className="h-[calc(100dvh-160px)] w-full overflow-hidden">
                <AutoSizer>
                    {({ height, width }) => (
                        <FixedSizeList
                            height={height}
                            itemCount={data.length}
                            itemSize={100}
                            width={width}
                            itemData={data}
                            className="px-4"
                            style={{ overflowX: 'hidden' }}
                        >
                            {Row}
                        </FixedSizeList>
                    )}
                </AutoSizer>
            </div>
        </PullToRefresh>
    );
};
